/**
 * Wraps admin pages. Redirects unauthenticated users to /admin/login while
 * preserving the original target via ?redirect=... so post-login lands them
 * back where they were.
 */
import React from "react";
import { Navigate, useLocation } from "react-router-dom";

import { useAdminAuth } from "../../lib/admin-auth";

export default function AdminProtectedRoute({ children, requiredRoles }) {
  const { isAuthenticated, admin } = useAdminAuth();
  const location = useLocation();

  if (!isAuthenticated) {
    const redirect = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/admin/login?redirect=${redirect}`} replace />;
  }

  if (requiredRoles && requiredRoles.length > 0 && admin?.role !== "super_admin") {
    if (!requiredRoles.includes(admin?.role)) {
      return (
        <div
          data-testid="admin-forbidden"
          className="mx-auto mt-20 max-w-md rounded-2xl border border-[#0F172A]/10 bg-white p-8 text-center"
        >
          <p className="text-[10px] uppercase tracking-[0.28em] text-[#B0413E]">
            Forbidden
          </p>
          <p className="mt-3 font-display text-2xl text-[#0F172A]">
            You don't have access to this page.
          </p>
          <p className="mt-2 text-sm text-[#0F172A]/55">
            Ask a super-admin to grant you the required role.
          </p>
        </div>
      );
    }
  }

  return children;
}
